import { render, staticRenderFns } from "./AllergyPrint.vue?vue&type=template&id=74834532&"
import script from "./AllergyPrint.vue?vue&type=script&lang=js&"
export * from "./AllergyPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports